import { messageAPI } from '@/services-ts/axios'
import type { IDeleteMessageTemplate, IPayloadMessageTemplate } from '@/types/Request'
import type { IMessageTemplateStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useMessageTemplateStore = defineStore('messageTemplate', {
  state: (): IMessageTemplateStore => ({
    messageTemplates: [],
  }),

  actions: {
    async GetMessageTemplateList() {
      const { status, data } = await messageAPI.MessageTemplateServices.GetMessageTemplateList()
      this.messageTemplates = status ? data : []
    },

    async CreateMessageTemplate(payload: IPayloadMessageTemplate) {
      const { status } = await messageAPI.MessageTemplateServices.CreateMessageTemplate(payload)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetMessageTemplateList()
      }
      return status
    },

    async UpdateMessageTemplate(payload: IPayloadMessageTemplate) {
      const { status } = await messageAPI.MessageTemplateServices.UpdateMessageTemplate(payload)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetMessageTemplateList()
      }
      return status
    },

    async DeleteMessageTemplate(payload: IDeleteMessageTemplate) {
      const { status } = await messageAPI.MessageTemplateServices.DeleteMessageTemplate(payload)

      if (status) {
        this.messageTemplates = this.messageTemplates.filter(item => item.id !== payload.Id)
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
    },
  },
})
